import { personTimelinePageSchema, timelineMessageBodySchema, type PersonTimelinePage, type TimelineMessageBody } from '@vigeo/shared';
import { fixtureMode } from '../../lib/data-mode.js';

/**
 * One page of a person's derived timeline, newest first, parsed with the schema the API
 * builds it with. `cursor` is the previous page's `nextCursor`, handed back untouched.
 */
export async function fetchPersonTimeline(personId: string, cursor: string | null = null): Promise<PersonTimelinePage> {
  if (fixtureMode) return { personId, entries: [], nextCursor: null };
  const query = cursor === null ? '' : `?cursor=${encodeURIComponent(cursor)}`;
  const response = await fetch(`/api/people/${encodeURIComponent(personId)}/timeline${query}`);
  if (!response.ok) throw new Error(`The timeline could not be loaded (status ${response.status}).`);
  return personTimelinePageSchema.parse(await response.json());
}

/** The whole stored text of one message a row previewed. */
export async function fetchTimelineMessage(personId: string, messageId: string): Promise<TimelineMessageBody> {
  const response = await fetch(`/api/people/${encodeURIComponent(personId)}/timeline/messages/${encodeURIComponent(messageId)}`);
  if (!response.ok) throw new Error(`The full message could not be loaded (status ${response.status}).`);
  return timelineMessageBodySchema.parse(await response.json());
}
